import linkedin from '../assets/linkedin3.png'
import ContactForm from '../components/contact/ContactForm'

export default function About() {
  return (  
    <div className="container">   
      <div className="page">

        <ContactForm></ContactForm>
      
        <hr className='line' />     

        <div className='container'
            style={{ textAlign: 'center',       
              border: '2px solid grey', 
              borderRadius: '1rem', 
              marginTop: '2rem', 
              height: '3.6rem', 
              minWidth: '20rem', 
              width: '20rem', 
              alignItems: 'center', 
              justifyContent: 'center', 
              gap: '0.5rem'}}   
        >

          <a href='https://www.linkedin.com/in/ivan-voropaev-b587642' target="_blank" rel="noreferrer" 
          style={{textDecoration: 'none',   
          minWidth: '19rem', 
          width: '19rem', 
          marginTop: '-0.3rem', 
          borderRadius: '0.5rem', 
          display: 'flex', 
          flexDirection: 'row', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: '0.5rem'}}>
            
              
              <img  src={linkedin} style={{  height: '3rem', objectFit: 'fill', marginTop: '8px', justifyContent: 'center',}} alt='LinkedIn' /> 

          
          </a>  
        </div>
      </div>    
    </div>
)}
